// purpose: URL クエリだけで有効化するデバッグフラグの解釈。env 変数は持たない（本番ビルドに焼き付かない）。

const GOD_MODE_KEY = 'god';
const TRUE_TOKENS = ['1', 'true', 'on'];

function queryToken(key: string): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get(key);
}

/**
 * ?god=1 で被弾を無効化し、併せて武器デバッグ土台（全装備所持・段位 MAX 開始 +
 * Digit1-4 コア / Z レンズ / X デバイス / C 段位のプレイ中巡回）を有効にする。
 * 最終ボスまでの進行検証と、全強化形態の目視確認の専用経路。
 */
export function isGodModeEnabled(): boolean {
  const raw = queryToken(GOD_MODE_KEY);
  if (raw === null) return false;
  return TRUE_TOKENS.includes(raw.trim().toLowerCase());
}
